import "./CreateEditUnits.scss";
import React, { useState, useEffect } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import { toast } from "react-toastify";
import BlueButton from "../../../../../components/BlueButton/BlueButton";
import api from "../../../../../utils/api";

// Common styles for InputLabel to reduce repetition
const commonLabelStyles = {
  background: "white",
  transformOrigin: "right top",
  transform: "translate(14px, -9px) scale(0.75)",
  right: 24,
  left: "auto",
  paddingLeft: "4px",
  paddingRight: "4px",
};

const CreateEditUnits = ({
  open,
  onClose,
  onOpen,
  currentView, // 'createUnit' or 'editUnit'
  initialData = null,
  refreshData,
  onSuccess,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: { ar: "", en: "" },
    active: true,
    type: "unit",
    color: "",
  });

  // Set initial form data if editing
  useEffect(() => {
    if (currentView === "editUnit" && initialData) {
      setFormData({
        name: {
          ar: initialData.name?.ar || "",
          en: initialData.name?.en || "",
        },
        active: initialData.active === "1" || initialData.active === true,
        type: "unit",
        color: initialData.color || "",
      });
    } else {
      // Reset form when opening create view
      setFormData({
        name: { ar: "", en: "" },
        active: true,
        type: "unit",
        color: "",
      });
    }
  }, [initialData, currentView]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const endpoint =
        currentView === "editUnit"
          ? `/variations/${initialData.id}`
          : "/variations";
      const method = currentView === "editUnit" ? "put" : "post";

      // Create a FormData object
      const formDataObj = new FormData();

      // Append all needed fields
      formDataObj.append("name[en]", formData.name.en);
      formDataObj.append("name[ar]", formData.name.ar);
      formDataObj.append("active", formData.active ? "1" : "0");
      formDataObj.append("type", "unit");

      // Create custom config for Axios to override the default JSON content type
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          // Authorization header will be added by the interceptor
        },
      };

      // Make API call with FormData and custom config
      await api[method](endpoint, formDataObj, config);

      toast.success(
        currentView === "editUnit"
          ? "تم تحديث الوحدة بنجاح"
          : "تم إضافة الوحدة بنجاح"
      );

      // Call onSuccess callback to trigger data refresh in parent
      if (onSuccess) {
        onSuccess();
      }

      // Also call refreshData if provided (for backward compatibility)
      if (refreshData) {
        refreshData();
      }

      // Close modal
      onClose();
    } catch (error) {
      toast.error(error?.message || "حدث خطأ ما");
    } finally {
      setIsLoading(false);
    }
  };

  const renderUnitForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "editUnit" ? "تعديل الوحدة" : "اضافة وحدة جديدة"}
      </p>
      <form onSubmit={handleSubmit}>
        {/* Name in Arabic */}
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-ar" shrink sx={commonLabelStyles}>
            اسم الوحدة بالعربية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-ar"
            type="text"
            value={formData.name.ar}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, ar: e.target.value },
              })
            }
          />
        </FormControl>

        {/* Name in English */}
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel htmlFor="name-en" shrink sx={commonLabelStyles}>
            اسم الوحدة بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="name-en"
            type="text"
            value={formData.name.en}
            onChange={(e) =>
              setFormData({
                ...formData,
                name: { ...formData.name, en: e.target.value },
              })
            }
          />
        </FormControl>

        {/* We could add a switch for active status if needed */}
        {/* <FormControlLabel
          control={
            <Switch
              checked={formData.active}
              onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
            />
          }
          label="تفعيل"
        /> */}

        <BlueButton
          text={currentView === "editUnit" ? "حفظ" : "اضافة"}
          size="medium"
          variant="fill"
          loading={isLoading}
          type="submit"
        />
      </form>
    </div>
  );

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {/* Only render if currentView is createUnit or editUnit */}
      {(currentView === "createUnit" || currentView === "editUnit") &&
        renderUnitForm()}
    </SwipeableDrawer>
  );
};

export default CreateEditUnits;
